<div class="attr-item">
  <b>{{ item.key }}: </b> {{ item.value || '---' }}
</div>
